import type { Agent } from "@agentic_system/api/agent";
import {
  Bot,
  Search,
  Lightbulb,
  Briefcase,
  FileText,
  Settings,
  HelpCircle,
  MessageCircle,
  User,
  MapPin,
  Building2,
  TrendingUp,
  Calendar,
  Star,
  Sparkles,
  Rocket,
  Target,
  Zap,
  type LucideIcon,
} from "lucide-react";
import { getPersonalizedGreeting } from "./greeting-utils";

// Icon lookup map for dynamic rendering
const ICON_MAP: Record<string, LucideIcon> = {
  bot: Bot,
  search: Search,
  lightbulb: Lightbulb,
  briefcase: Briefcase,
  "file-text": FileText,
  settings: Settings,
  "help-circle": HelpCircle,
  "message-circle": MessageCircle,
  user: User,
  "map-pin": MapPin,
  building: Building2,
  "trending-up": TrendingUp,
  calendar: Calendar,
  star: Star,
  sparkles: Sparkles,
  rocket: Rocket,
  target: Target,
  zap: Zap,
};

interface AgentBadgesProps {
  agents: Agent[];
  onAgentClick: (agent: Agent) => void;
  disabled?: boolean;
}

interface ChatEmptyHeaderProps {
  userName?: string;
}

// Header component for empty chat state
export function ChatEmptyHeader({ userName }: ChatEmptyHeaderProps) {
  const greeting = getPersonalizedGreeting(userName);

  return (
    <div className="text-center">
      <Bot className="w-12 h-12 text-slate-400 mx-auto mb-3" />
      <p className="text-base text-slate-600 mb-2">
        {greeting}
      </p>
      <h2 className="text-lg font-medium text-slate-700">
        Comment puis-je vous aider ?
      </h2>
    </div>
  );
}

// Badges only (question buttons)
export function AgentBadges({
  agents,
  onAgentClick,
  disabled,
}: AgentBadgesProps) {
  return (
    <div className="flex flex-wrap justify-center gap-2 max-w-[800px]">
      {agents.map((agent) => {
        const IconComponent = agent.icon ? ICON_MAP[agent.icon] : null;
        return (
          <button
            key={agent.id}
            onClick={() => onAgentClick(agent)}
            disabled={disabled}
            className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 bg-white border border-slate-200 rounded-full text-slate-700 hover:bg-slate-50 hover:border-default-300 hover:text-default-600 hover:bg-default-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed shadow-sm"
          >
            {IconComponent && <IconComponent className="w-3.5 h-3.5" />}
            {agent.user_facing_question}
          </button>
        );
      })}
    </div>
  );
}
